import { Crown } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const CaptainPicker = ({ data, act }) => {
  const { user } = useAuth();
  const m = data.match;
  const confirmed = data.players.filter((p) => p.registration_status === "confirmed");
  const can = m.status === "scheduled" && !m.teams_locked && (data.me.is_participant || user.role === "admin");
  const first = data.draft.first || "white";
  const canFirst = can && !confirmed.some((p) => p.team && !p.is_captain);
  return (
    <div data-testid="captain-picker" className="rounded-3xl bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 p-4 space-y-2.5">
      <p className="text-[11px] font-black tracking-[0.2em] text-amber-600 flex items-center gap-1.5"><Crown className="w-4 h-4" /> CAPITAINES</p>
      {["white", "black"].map((t) => (
        <div key={t} className="flex items-center gap-2">
          <span className={`w-20 shrink-0 text-center rounded-full py-1 text-[10px] font-black ${t === "white" ? "bg-white text-zinc-950 border border-slate-300" : "bg-zinc-950 text-white"}`}>{t === "white" ? "BLANC" : "NOIR"}</span>
          <select data-testid={`captain-select-${t}`} disabled={!can} className="gg-input !py-2.5 flex-1" value={m[`captain_${t}`] || ""}
            onChange={(e) => e.target.value && act("put", "/captains", { team: t, user_id: e.target.value }, "Capitaine nommé")}>
            <option value="">— Nommer un capitaine —</option>
            {confirmed.map((p) => <option key={p.id} value={p.id}>{p.short_name}{p.is_guest ? " (invité)" : ""}</option>)}
          </select>
        </div>
      ))}
      <div data-testid="draft-first-picker" className="pt-1">
        <p className="text-[11px] font-bold text-amber-700 mb-1.5">Qui choisit en premier ?</p>
        <div className="grid grid-cols-2 gap-1.5">
          {[["white", "Capitaine Blanc"], ["black", "Capitaine Noir"]].map(([t, l]) => (
            <button key={t} data-testid={`draft-first-${t}`} disabled={!canFirst} onClick={() => t !== first && act("put", "/draft/first", { first: t }, `${l} commence`)}
              className={`rounded-xl py-2 text-xs font-bold border transition-colors disabled:opacity-60 ${first === t ? "bg-amber-400 text-zinc-950 border-amber-300" : "bg-white border-amber-200 text-slate-600"}`}>{l}</button>
          ))}
        </div>
        {can && !canFirst && <p className="text-[11px] text-slate-500 mt-1">Des joueurs ont déjà été choisis.</p>}
      </div>
      {!can && m.status === "scheduled" && <p className="text-[11px] text-slate-500">{m.teams_locked ? "Équipes verrouillées." : "Inscrivez-vous au match pour nommer un capitaine."}</p>}
    </div>
  );
};
